import { updateQuizDescriptionMutation } from 'chameleon-src/queries/mutations';

const updateQuizDescription = async (client, variables) => {
  const response = await client.mutate({
    mutation: updateQuizDescriptionMutation,
    fetchPolicy: 'network-only',
    variables,
  });
  const { updateQuizDescription: { ok } = {} } =
    (response && response.data) || {};
  return ok;
};

export default updateQuizDescription;
